/**
 * Directive to allow repeatedly triggering an action while the mouse is held down or while element is being touched
 *
 * e.g.
 *
 * <button x-hold.250ms="console.log('clicked')">Hold me down</button>
 */
export default ($el, {modifiers, expression}, {cleanup, evaluate}) => {
  let intervalId = null;
  let firstModifier = modifiers[0] || '';
  let time = Number.isInteger(firstModifier.split('ms')[0]) ? Number(firstModifier.split('ms')[0]) : 25;

  const startAction = () => {
    intervalId = setInterval(() => {
      evaluate(expression);
    }, time);
  };

  const stopAction = () => {
    clearInterval(intervalId);
  };

  $el.addEventListener('mousedown', startAction);
  $el.addEventListener('mouseup', stopAction);
  $el.addEventListener('mouseleave', stopAction);
  $el.addEventListener('touchstart', startAction);
  $el.addEventListener('touchend', stopAction);

  cleanup(() => {
    $el.removeEventListener('mousedown', startAction);
    $el.removeEventListener('mouseup', stopAction);
    $el.removeEventListener('mouseleave', stopAction);
    $el.removeEventListener('touchstart', startAction);
    $el.removeEventListener('touchend', stopAction);
  });
};
